import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js';
 import {AgentsService} from "../../../services/index.js";

const ViewAgent = () => { 
    
const [agent, setAgent] = useState({});
const [loading, setLoading] = useState(false);
const { id } = useParams();
const navigate = useNavigate()

    const getAgent = () => {
        setLoading(true);
        AgentsService.getAgentDetails(id)
              .then(response => {
                const data =response.data.data
                setAgent(data)
                setLoading(false);
              })
              .catch(error => {
                setLoading(false);
                try {
                  const errorMessage = error.response.data
                  toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                } catch (e){
                  toast.error( MESSAGES.SERVER_ERROR)
                }
              });
      }
    useEffect(() => {
        getAgent();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
const back = () => {
  navigate(-1); 
}
const approveAgent = (row) => {
 
  navigate(`/approve-agent/${row.user_id}`)
}
return(
  <div>
  <LoaderOverlay loading={loading} />
  <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
  <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>View Details</h4>
  <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Profile Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">USER ID</label>
                  <p>{agent.user_id}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">FULL NAME</label>
                  <p>{agent.full_name}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">EMAIL ADDRESS</label>
                  <p>{agent.email_address}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MOBILE NUMBER</label>
                  <p>{agent.mobile_number}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">{agent.status_id}</label>
                  <p>1</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATUS</label>
                  <p>{agent.status}</p>
                </div>
              </div>
              
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CUSTOMER ID</label>
                  <p>{agent.customer_id}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">USER TYPE</label>
                  <p>{agent.user_type}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">AGENT ID</label>
                  <p>{agent.agent_id}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">SUPERVISOR</label>
                  <p>{agent.supervisior || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISSION GROUP ID</label>
                  <p>{agent.comm_grp_id || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">LIMIT GROUP ID</label>
                  <p>{agent.limit_grp_id || '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">DATE OF BIRTH</label>
                  <p>{agent.date_of_birth || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">GENDER</label>
                  <p>{agent.gender || '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">GENDER ID</label>
                  <p>{agent.gender_id || '-'}</p>
                </div>
              </div> */}
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">IS VERIFICATION PENDING</label>
                  <p>{agent.is_verification_pending ? 'true' : 'false'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">NATIONAL ID</label>
                  <p>{agent.national_id || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISION GROUP NAME</label>
                  <p>{agent.comm_grp_name || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">LIMIT GROUP NAME</label>
                  <p>{agent.limit_grp_name || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">WALLET BALANCE</label>
                  <p>₹{agent.balances && agent.balances.pay_in_balance ? agent.balances.pay_in_balance : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PROFILE PHOTO</label><br />
                  <img style={{margin: 0}} src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Address Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 1</label>
                  <p>{agent.address && agent.address.address1 ? agent.address.address1 : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 2</label>
                  <p>{agent.address && agent.address.address2 ? agent.address.address2 : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY ID</label>
                  <p>{agent.address && agent.address.city_id ? agent.address.city_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY</label>
                  <p>{agent.address && agent.address.city ? agent.address.city : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE ID</label>
                  <p>{agent.address && agent.address.state_id ? agent.address.state_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE</label>
                  <p>{agent.address && agent.address.state ? agent.address.state : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ZIP</label>
                  <p>{agent.address && agent.address.zip ? agent.address.zip : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Balance Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY IN BALANCE</label>
                  <p>₹{agent.balances && agent.balances.pay_in_balance ? agent.balances.pay_in_balance : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY OUT BALANCE</label>
                  <p>₹{agent.balances && agent.balances.blocked_amount ? agent.balances.blocked_amount : 0}</p>
                </div>
              </div>
              
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED BY</label>
                  <p>{agent.created_by || '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Registered ON</label>
                  <p>{agent.created_on || '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-bg-theme-Color backbt">Back</button></a>
    {
      agent.is_verification_pending && (
        <a style={{width: 'auto', padding: '0px'}}  onClick={() => approveAgent(agent)} ><button className="btn btn-bg-theme-Color cfrmbt">Approve</button></a>
      )
    }
   
  </div>
</div>

</div>

)

} 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(ViewAgent));